function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_921_18279)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 10.5C7.76143 10.5 10 8.26142 10 5.5C10 2.73858 7.76143 0.5 5 0.5C2.23857 0.5 0 2.73858 0 5.5C0 8.26142 2.23857 10.5 5 10.5ZM35 14.5C32.2472 14.5 30 16.8371 30 19.7C30 25.4258 25.5056 30.1 20 30.1C14.4944 30.1 10 25.4258 10 19.7C10 16.8371 7.75281 14.5 5 14.5C2.24719 14.5 0 16.8371 0 19.7C0 31.1517 8.93259 40.5 20 40.5C31.0112 40.5 40 31.2101 40 19.7C40 16.7787 37.7528 14.5 35 14.5ZM40 5.5C40 8.26142 37.7614 10.5 35 10.5C32.2386 10.5 30 8.26142 30 5.5C30 2.73858 32.2386 0.5 35 0.5C37.7614 0.5 40 2.73858 40 5.5Z",
  fill: "#00B2A9"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_921_18279"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white",
  transform: "translate(0 0.5)"
})));
var SvgMobiautoGreen = function SvgMobiautoGreen(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobiautoGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mobiauto-green.3e16caec.svg";
export { ForwardRef as ReactComponent };